













import { Component, Vue, Prop } from "vue-property-decorator";
import PrestadorModel from "@/models/cadastros/saude/PrestadorModel";

@Component
export default class ItemAtendimento extends Vue {
  @Prop({ required: true })
  prestadorProfissional!: PrestadorModel;

  get cpfCnpj(): string | undefined {
    let cpfCnpj = this.prestadorProfissional.cpfCnpj;
    if (cpfCnpj) {
      if (cpfCnpj.length > 11) {
        cpfCnpj = "CNPJ: " +cpfCnpj.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
          "$1.$2.$3/$4-$5"
        );
      } else {
        cpfCnpj = "CPF: " + cpfCnpj.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/,
          "$1.$2.$3-$4"
        );
      }
    }
    return cpfCnpj;
  }

  get enderecoCompleto() {
    const endereco = this.prestadorProfissional.endereco;
    let enderecoCompleto = `${endereco?.logradouro}, `;
    if (endereco?.numero) {
      enderecoCompleto += `${endereco?.numero}, `;
    }
    if (endereco?.complemento) {
      enderecoCompleto += `${endereco.complemento}, `;
    }
    if (endereco?.bairro) {
      enderecoCompleto += `${endereco.bairro}, `;
    }
    enderecoCompleto += `${endereco?.cidade.nome}`;
    if (endereco?.cidade?.estado) {
      enderecoCompleto += `-${endereco?.cidade?.estado} `;
    }

    if (endereco?.cep) {
      enderecoCompleto += ` cep: ${endereco?.cep} `;
    }

    return enderecoCompleto;
  }

  get telefones() {
    return this.prestadorProfissional.telefones &&
      this.prestadorProfissional.telefones.length > 0
      ? this.prestadorProfissional.telefones
          .map(
            telefone =>
              `(${telefone?.ddd}) ${telefone.numero} ramal: ${telefone.ramal}`
          )
          .reduce((acumulado, atual) => {
            return `${acumulado} / ${atual}`;
          })
      : "";
  }

  get profissional(): string | undefined {
    let prestador = "";
    if (this.prestadorProfissional.profissional) {
      prestador = this.prestadorProfissional.profissional.nome;
    }
    if (this.prestadorProfissional?.profissional?.numeroRegistro) {
      prestador = `registro: ${this.prestadorProfissional?.profissional?.numeroRegistro}`;
    }
    return prestador;
  }
}
